// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2nBSM","requiredAsterisk":"Info_requiredAsterisk__1x_PV"};